import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tree-three"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "pay-desc" }
const _hoisted_4 = { class: "list-title" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "video" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "video-desc"
}
const _hoisted_10 = { class: "video-desc-text" }
const _hoisted_11 = {
  key: 1,
  class: "video-tip"
}
const _hoisted_12 = { class: "video-tip-text" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "ct-box" }
const _hoisted_15 = {
  key: 0,
  class: "pay-label"
}
const _hoisted_16 = { class: "pay-text" }
const _hoisted_17 = { class: "course-title" }
const _hoisted_18 = { class: "c-b" }
const _hoisted_19 = { class: "course-score" }
const _hoisted_20 = { class: "course-learn" }

import { ref, computed, watch, onActivated } from 'vue'
import { useThemeColor, useThemeId, useThemeColorWithAlpha } from '@/utils/theme'
import { RecordHome, GoodsInfo } from '@/api/Models/CourseDetail'
import { useI18n } from 'vue-i18n'
import Error from '@/components/Error.vue'
import { TreeItem, ThildrenItem } from '../types'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import PullToRefresh from '@/components/PullToRefresh.vue'
const minHeight = 'calc(100vh - 100px)'

interface IProps {
  data: RecordHome[]
  total: number
  currentChildren: TreeItem | ThildrenItem
  goodsInfo: GoodsInfo[]
}
// eslint-disable-next-line

export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollList',
  props: {
    data: { default: () => [] },
    total: { default: 0 },
    currentChildren: { default: () => ({
    id: '',
    name: '',
    parentId: '',
    categoryLevel: 0,
    courseNum: '',
    count: '',
    hasChildren: 0,
    children: []
  }) },
    goodsInfo: { default: () => [] }
  },
  emits: ['onSelectTreeThree', 'showPay', 'onRefresh'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v7b0bff02": (_unref(themeLinearColorWithAlpha)),
  "v2cc8e00a": (_unref(themeColor)),
  "v29b41306": (_unref(themeColorWithAlpha)),
  "v1bb73d98": (payThemeTextColor.value)
}))

const props = __props
const themeColorWithAlpha = useThemeColorWithAlpha(0.2)
const themeLinearColorWithAlpha = useThemeColorWithAlpha(0.3)
const emits = __emit
const refreshing = ref(false)
const { t } = useI18n()
const router = useRouter()
const themeColor = useThemeColor()
const themeType = useThemeId()
const currentTreeThreeIndex = ref(-1)
let scrollH = 0
const pullRefreshRef = ref()
onBeforeRouteLeave(() => {
  // 确保 pullRefreshRef 和其对应的 DOM 元素存在
  if (pullRefreshRef.value && pullRefreshRef.value.scrollTop) {
    // 获取滚动位置
    scrollH = pullRefreshRef.value.scrollTop
  }
})
// 在返回让页面滚动到之前的高度
onActivated(() => {
  try {
    pullRefreshRef.value.scroll(0, scrollH)
  } catch (e) {}
})
const onSelectTreeThree = (isAll: boolean, index: number) => {
  currentTreeThreeIndex.value = index
  const param = isAll ? props.currentChildren : props.currentChildren.children[currentTreeThreeIndex.value]
  emits('onSelectTreeThree', param)
}
const onRefresh = () => {
  if (refreshing.value) {
    refreshing.value = false
  }
  emits('onRefresh')
}
const getTreeThreeBackgroundColor = computed(() => () => {
  switch (themeType.value) {
    case 'red':
      return 'rgba(230, 0, 0, 0.25)'
    case 'blue':
      return 'rgba(0, 117, 255, 0.25)'
    case 'orange':
      return 'rgba(243, 155, 0, 0.25)'
  }
})

const payThemeTextColor = computed(() => {
  let color = ''
  switch (themeType.value) {
    case 'red':
      color = '#850000'
      break
    case 'blue':
      color = '#003685'
      break
    case 'orange':
      color = '#855500'
      break
  }
  return color
})
// 0 传不进来
const getName = computed(() => (type: number) => {
  // 类型 0:课程，1:文档，2:视频，3:图片，4:音频，5:交互视频
  switch (type) {
    case 0:
      return t('app_course')
    case 1:
      return t('tag_doc')
    case 2:
      return t('tag_video')
    case 3:
      return t('tag_pic')
    case 4:
      return t('audio')
    case 6:
      return t('superplayer_interactive')
  }
})
watch(
  [() => props.currentChildren],
  () => {
    currentTreeThreeIndex.value = -1
    pullRefreshRef.value.scroll(0, 0)
  },
  { deep: true }
)

const goDetail = (item: RecordHome) => {
  const paramsRouter = {
    id: item.fileId, // 课程包id
    courseId: '', // 课件id
    courseType: item.fileType >= 1 ? 'courseWare' : 'course',
    endingType: 0, // 结课方式
    channel: 0 // 渠道
  }
  router.push({ name: 'courseDetail', query: paramsRouter })
}

const showPay = () => {
  emits('showPay')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "scroll-list",
    ref_key: "pullRefreshRef",
    ref: pullRefreshRef
  }, [
    _createVNode(PullToRefresh, {
      refreshing: refreshing.value,
      "onUpdate:refreshing": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      "min-height": minHeight
    }, {
      default: _withCtx(() => [
        (__props.currentChildren.categoryLevel === 2 && __props.currentChildren.hasChildren)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "tree-three-item",
                style: _normalizeStyle({
            background: currentTreeThreeIndex.value === -1 ? getTreeThreeBackgroundColor.value() : '#F7F8F9',
            color: currentTreeThreeIndex.value === -1 ? _unref(themeColor) : '#171921'
          }),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onSelectTreeThree(true, -1)))
              }, " 全部 ", 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentChildren.children, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tree-three-item",
                  style: _normalizeStyle({
            background: currentTreeThreeIndex.value === index ? getTreeThreeBackgroundColor.value() : '#F7F8F9',
            color: currentTreeThreeIndex.value === index ? _unref(themeColor) : '#171921'
          }),
                  key: item.id,
                  onClick: ($event: any) => (onSelectTreeThree(false, index))
                }, _toDisplayString(item.name), 13, _hoisted_2))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (__props.goodsInfo.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "pay-course",
              onClick: showPay
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "pay-m" }, "￥", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('board_total_course_h5', { length: __props.goodsInfo.length || 0 })), 1),
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "iconfont icon-icon_tiaozhuan pay-jump" }, null, -1))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('app_total_course_h5', { length: __props.total || 0 })), 1),
        (__props.data.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (goDetail(item)),
                  class: "list-item",
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      class: "video-cover",
                      src: item.coverImgUrl,
                      alt: ""
                    }, null, 8, _hoisted_8),
                    (item.fileType + 1 > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(getName.value(item.fileType)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.learnStatus === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('app_learned_short')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (item.purchaseStatus === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('purchased')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.fileName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(item.score || 0) + _toDisplayString(_ctx.$t('app_score')), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "course-line" }, null, -1)),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.learnNum || 0) + _toDisplayString(_ctx.$t('app_people_learning')), 1)
                    ])
                  ])
                ], 8, _hoisted_6))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(Error, {
              key: 3,
              status: { info: _ctx.$t('app_empty'), imgSrc: 'empty_cont.png' },
              "self-style": { width: '100%', height: 'calc(100vh - 150px)', background: 'none' }
            }, null, 8, ["status"]))
      ]),
      _: 1
    }, 8, ["refreshing"])
  ], 512))
}
}

})